// @flow
import * as React from 'react';
import Link from 'gatsby-link';
import logoDefault from '../img/ftsblack.png';
import logoInverse from '../img/ftswhite.png';

export const Logo = (props: {
  prefix: string;
  inverse: boolean;
  siteName: string;
}) => (
  <Link href to={`${props.prefix}/`} className="navbar-brand">
    <img className="logo-dark" src={logoDefault} width={150} height={60} alt={props.siteName} />
    {props.inverse &&
    <img className="logo-light" src={logoInverse} width={150} height={60} alt={props.siteName} />}
  </Link>);

export default Logo;



// WEBPACK FOOTER //
// ./src/layouts/Logo.jsx